<template>
  <div
    :class="`d-flex justify-content-between align-items-center ${
      departmentArchived ? 'strike-through' : ''
    }`"
  >
    {{ departmentName ? departmentName : "--" }}
    <Tooltip placement="top" :options="{ hideOnClick: true }">
      <template #trigger>
        <i class="fas fa-edit ml-2 link" @click="toggleModal"></i>
      </template>
      <template #tooltip>
        <div class="text-center p-2">Change department<br /></div>
      </template>
    </Tooltip>
    <DepartmentEditModal
      v-if="ownerModal"
      :department-id="departmentId"
      :department-name="departmentName"
      :job-id="jobId"
      :confirm-changes="confirmChanges"
      @hide-modal="toggleModal"
    ></DepartmentEditModal>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import Tooltip from "../components/Tooltip.vue";
import DepartmentEditModal from "./DepartmentEditModal.vue";

defineProps({
  jobId: {
    type: Number,
    default: null
  },
  departmentId: {
    type: Number,
    default: null
  },
  departmentName: {
    type: String,
    default: null
  },
  departmentArchived: {
    type: Boolean,
    default: false
  },
  confirmChanges: {
    type: Boolean,
    default: false
  }
});

const ownerModal = ref(false);

function toggleModal() {
  ownerModal.value = !ownerModal.value;
}
</script>

<style lang="scss" scoped></style>
